import { Box, Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/** STYLE */

/** API */
import ImportInventoryApi from 'api/warehouses/import-inventory.api';
import { routeName } from 'routes/routes-name';

/** UTILS || SLICE */
import { showModal } from 'app/slice/modal.slice';
import { numberFormat, toBuddhistYear } from 'utils/app.utils';
import { isUpdate } from 'utils/verification.utils';

/** COMPONENT */
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import { colors } from 'constants/theme';
import PopupCancelImport from 'features/warehouses/import-products/popupCancelImport';
import _ from 'lodash';
import { NetPrice } from './style';

const permissions = {
  isUpdate: isUpdate()
}

export default function ImportProductList() {
  const location = useLocation()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [document, setDocument]: any = useState({})
  const [popupCancel, setPopupCancel] = useState(false);

  const findDocumentById = async (inventoryDocumentId: number) => {
    const res = await ImportInventoryApi.findDocumentById(inventoryDocumentId)
    if (res.status === 200) {
      setDocument(res.data)
    }
  }

  useEffect(() => {
    if (location.state) {
      const data: any = location.state
      findDocumentById(data.inventoryDocumentId)
    } else {
      const queryParams = new URLSearchParams(window.location.search)
      const inventoryDocumentId = Number(queryParams.get("id"))
      findDocumentById(inventoryDocumentId)
    }
  }, [location])

  const onCancel = () => {
    dispatch(showModal())
    setPopupCancel(true)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '60px' },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.LOT_NO') },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.PRODUCT_LIST') },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.EXPIRATION_DATE'), width: '150px' },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.COUNT'), align: 'center', width: '90px' },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.UNIT'), align: 'left', width: '100px' },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.PRICE'), align: 'right', width: '155px' },
    { id: 'message', disablePadding: false, label: t('IMPORT_PRODUCT.FORM.TOTAL'), align: 'right', width: '155px', class: 'p-3' },
  ]

  const renderProduct = (objData: any, no: number) => {
    const { itemName, expireDate, qty, itemUnitName, costPrice, total, lotNo } = objData
    no = no + 1
    const objRenderData = {
      key: no.toString(),
      id: no.toString(),
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: lotNo || '-' },
        { option: 'TEXT', align: 'left', label: itemName || '-' },
        { option: 'TEXT', align: 'left', label: expireDate && expireDate !== '0000-00-00' ? toBuddhistYear(moment(expireDate)) : '-' },
        { option: 'TEXT', align: 'center', label: qty },
        { option: 'TEXT', align: 'left', label: itemUnitName || '-' },
        { option: 'TEXT', align: 'right', label: numberFormat(costPrice) },
        { option: 'TEXT', align: 'right', label: numberFormat(total || qty * costPrice) },
      ]
    }
    return <TableRowCommon  {...objRenderData} />
  }

  return (
    <Box>
      <Box display="flex" flexDirection="column">
        <HeaderLabel
          text={t('IMPORT_PRODUCT.FORM.IMPORT_PRODUCT_DETAIL')}
          unDisplayButton
          unDisplayCancel
          ondelete={onCancel}
          disabledDelete={document.status === 'ACTIVE' ? (document.cInven > 0 ? true : permissions.isUpdate.disabled) : true}
          navigator={{
            previousTo: routeName.importProduct,
            previousTitle: t('IMPORT_PRODUCT.TITLE'),
            currentTitle: t('IMPORT_PRODUCT.FORM.IMPORT_PRODUCT_DETAIL')
          }}
        />
      </Box>
      <Box sx={{ border: '1px solid ' + colors.lightGray, boxShadow: 1, mx: 3, mb: 3, borderRadius: '8px', bgcolor: '#fff' }} >
        <Box sx={{ py: 2, px: 3, overflow: 'auto', display: 'flex', flexDirection: 'column' }} >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={4}>
              <Box display="flex">
                <Typography sx={{ width: 120, fontWeight: 500, flex: 'none' }}>
                  {t('IMPORT_PRODUCT.TABLE.DATE')}
                </Typography>
                <Typography>
                  {document.date && document.date !== '0000-00-00'
                    ? toBuddhistYear(moment(document.date))
                    : '-'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Box display="flex">
                <Typography sx={{ width: 120, fontWeight: 500, flex: 'none' }}>
                  {t('IMPORT_PRODUCT.TABLE.DOCUMENT_NO')}
                </Typography>
                <Typography>
                  {(
                    document.prefix &&
                    document.documentNo &&
                    `${document.prefix}-${document.documentNo}`
                  ) || document.documentNo || '-'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Box display="flex">
                <Typography sx={{ width: 120, fontWeight: 500, flex: 'none' }}>
                  {t('IMPORT_PRODUCT.TABLE.DOCUMENT_NAME')}
                </Typography>
                <Typography>{document.subject || '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Box display="flex">
                <Typography sx={{ width: 120, fontWeight: 500, flex: 'none' }}>
                  {t('IMPORT_PRODUCT.FORM.BRANCH')}
                </Typography>
                <Typography>{document.branch?.branchName || '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Box display="flex">
                <Typography sx={{ width: 120, fontWeight: 500, flex: 'none' }}>
                  {t('IMPORT_PRODUCT.TABLE.UPDATEDBY')}
                </Typography>
                <Typography>{document.updatedBy || '-'}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ my: 3, borderColor: colors.lightGray }} />
          <TableCustom
            page={0}
            pageLimit={0}
            sortType={'ASC'}
            sortBy={''}
            rowCount={0}
            textEmptyData={t('REGISTER.NO_ITEM')}
            onSort={() => { return }}
            setPageLimit={() => { return }}
            setPage={() => { return }}
            headCells={headCells}
            rowsData={_.map(document.inventoryHistories, renderProduct)}
            hidePagination
          />
          <NetPrice className={`d-flex align-items-center justify-content-between justify-content-md-end mt-3 px-3 px-md-4`}>
            {`${t('IMPORT_PRODUCT.FORM.PRODUCT_PRICEALL')} ${numberFormat(!_.isEmpty(document.inventoryHistories) ? _.sumBy(document.inventoryHistories, 'total') : 0)} ${t('IMPORT_PRODUCT.FORM.PRICE_UNIT')}`}
          </NetPrice>
        </Box>
      </Box>
      {popupCancel && (
        <PopupCancelImport
          inventoryDocumentId={document.inventoryDocumentId}
          document={{
            prefix: document.prefix,
            documentNo: document.documentNo
          }}
          onCancel={show => setPopupCancel(show)}
          onAfterSubmit={show => {
            setPopupCancel(show)
            findDocumentById(document.inventoryDocumentId)
          }}
        />
      )}
    </Box>
  )
}

